// Admin-editable targets for R1 Monthly Scorecard. Seeded with metric labels only
// (target_value NULL) — targets are a business decision (unit economics/OKRs), not
// something the code should invent. The scorecard report shows "-" for status until
// a target is filled in here.
let churnScorecardTargetsSection = {
  name: "Target Scorecard",
  slug: "churnScorecardTargets",
  visible: true,
  singularName: "Target Scorecard",
  crud: true,
  endpoint: "/crud/churn_scorecard_targets",
  updateLabel: "label",
  filters: [],
  meta: {
    delete_flag: false,
  },
  access: ["superadmin"],
  delete: false,
  add: false,
  update: true,
  edit: true,
  exportToCsv: false,
  fields: [
    {
      label: "Metrik",
      name: "label",
      type: "text",
      visible: true,
      input: false,
    },
    {
      label: "Target",
      name: "target_value",
      type: "number",
      visible: true,
      resource_label: (row) => (row && row.target_value != null ? row.target_value : "Belum diset"),
    },
    {
      label: "Arah",
      name: "direction",
      type: "lookup",
      visible: true,
      values: [
        { value: "gte", text: "Makin tinggi makin baik (≥)" },
        { value: "lte", text: "Makin rendah makin baik (≤)" },
      ],
      resource_label: (row) => (row && row.direction === "lte" ? "≤ (makin rendah makin baik)" : "≥ (makin tinggi makin baik)"),
    },
  ],
};

export default [churnScorecardTargetsSection];
